// extracted by mini-css-extract-plugin
export default {"shell":"Layout_shell__hxw2p","main":"Layout_main__FxQfo"};